import { Stack } from '@mui/material'
import { pick } from 'ramda'
import { useParams } from 'react-router-dom'

import { HistoricList, PublishDialog } from '@/components'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'
import { useListHistory } from '@/hooks'
import {
  useGetCustomComponent,
  useUpdateCustomComponent,
} from '@/screens/ComponentLibrary/hooks'
import {
  CustomComponentEnhanced,
  storeKey,
} from '@/screens/ComponentLibrary/hooks/CONSTANTS'

import { parseDataDump } from './ConfigData'

type Recipe = {
  recipe: string
}
interface RecipeEnhanced extends CustomComponentEnhanced<Recipe> {}

export const History = () => {
  const { orgID } = useParams<{
    orgID: string
  }>()
  const { componentID } = useComponentProvider()

  const queryKey = [storeKey, componentID, 'history']

  const updateSemanticSearch = useUpdateCustomComponent<Recipe>(componentID)
  const currentSemanticSearch = useGetCustomComponent<Recipe>(componentID)
  const historyQuery = useListHistory(
    queryKey,
    'customComponent',
    {
      id: componentID,
    },
    parseDataDump
  )
  const parseData = (data?: RecipeEnhanced | null) => {
    if (!data) return {}
    return pick(['name', 'description', 'settings', 'type'], data)
  }

  const restoreVersion = async (data: Record<string, unknown>) => {
    await updateSemanticSearch.mutateAsync({
      ...parseData(data as unknown as CustomComponentEnhanced<Recipe>),
    } as RecipeEnhanced)
  }

  return (
    <Stack height="70vh">
      <HistoricList data={historyQuery.data} restore={restoreVersion} />
      <PublishDialog
        dataToSave={parseData(currentSemanticSearch.data)}
        extraInfo={{
          customComponentHistoryId: componentID,
          organizationHistoryId: orgID,
        }}
        queryKey={queryKey}
      />
    </Stack>
  )
}
